export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6253.c6367719.jpg";